import { Item } from '../../../../../store/types'
import Carousel from './CustomCarousel'
import { t } from 'i18next'
import { Stack, Typography } from '@mui/material'
import i18n from '../../../../../config/i18n'
import { environment } from '../../../../../enviroments/enviroment'

const translationBase = 'components.infoSidebar.schedule.carousel.delete'
const urlBase = `${environment.publicUrl}/assets/image/carousel/info/delete`

const LIGHT_PL_1 = `${urlBase}/delete-light-PL-1.png`
const DARK_PL_1 = `${urlBase}/delete-dark-PL-1.png`
const LIGHT_EN_1 = `${urlBase}/delete-light-EN-1.png`
const DARK_EN_1 = `${urlBase}/delete-dark-EN-1.png`

const DeleteCarousel = () => {
  const isPolish = i18n.language === 'pl'
  const items: Item[] = [
    {
      subtitle: t(`${translationBase}.deletePlanned.subtitle`),
      description: (
        <Stack gap={2}>
          <Typography>{t(`${translationBase}.deletePlanned.description-1`)}</Typography>
          <Typography>{t(`${translationBase}.deletePlanned.description-2`)}</Typography>
          <Typography>{t(`${translationBase}.deletePlanned.description-3`)}</Typography>
          <Typography>{t(`${translationBase}.deletePlanned.description-4`)}</Typography>
        </Stack>
      ),
      imageLight: isPolish ? LIGHT_PL_1 : LIGHT_EN_1,
      imageDark: isPolish ? DARK_PL_1 : DARK_EN_1,
      key: 'carousel-schedule-info-delete-1',
    },
  ]

  return <Carousel title={t(`${translationBase}.title`)} items={items} />
}

export default DeleteCarousel
